export default __webpack_public_path__ + "static/media/TimeLogger.36fc8b34.jpg";